import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AttributeFacet } from '@mp/shared/facets/domain';

import {
  ArticleFacetDrilldownSearchRequest,
  ArticleFacetSearchRequest,
  DrilldownFacetType,
  FacetResult,
} from '../models';

export const ArticleSearchFacetsActions = createActionGroup({
  source: 'Medical Shop - ArticleSearch',
  events: {
    'Fetch facets': props<{ request: ArticleFacetSearchRequest }>(),
    'Fetch facets success': props<{ facets: FacetResult }>(),
    'Fetch facets error': emptyProps(),
    'Fetch drilldown facet': props<{ request: ArticleFacetDrilldownSearchRequest }>(),
    'Fetch drilldown facet success': props<{
      facetType: DrilldownFacetType;
      facet: AttributeFacet;
    }>(),
    'Fetch drilldown facet error': emptyProps(),
  },
});

export const StartPageFacetsActions = createActionGroup({
  source: 'Medical Shop - StartPage',
  events: {
    'Fetch facets': props<{ request: ArticleFacetSearchRequest }>(),
    'Fetch facets success': props<{ facets: FacetResult }>(),
    'Fetch facets error': emptyProps(),
  },
});
